import Component from '@glimmer/component';

export interface MailerTemplateEditorAttributeHeadingComponentSignature {
  Args: {
    isDefault?: boolean;
    active?: boolean;
    resetAttribute?: () => void;
  };

  Element: HTMLDivElement;
}

export default class MailerTemplateEditorAttributeHeadingComponent extends Component<MailerTemplateEditorAttributeHeadingComponentSignature> {
  get showResetLink(): boolean {
    const { isDefault, active, resetAttribute } = this.args;

    if (isDefault) return false;
    if (!active) return false;

    return typeof resetAttribute === 'function';
  }
}
